import screenshotTabSelectionMigration from './screenshot_tab_selection.migration';

const migrations = {
  ...screenshotTabSelectionMigration
};

export default migrations;
